// extracted by mini-css-extract-plugin
module.exports = {"chart_card":"ChartCard_chart_card__3Au7e","chart_card_title":"ChartCard_chart_card_title__3nGf3","chart_card_content":"ChartCard_chart_card_content__2IKjZ"};